export const GET_DEPARTMENTS_REQUEST = 'DEPARTMENTS/GET_DEPARTMENTS_REQUEST';
export const GET_DEPARTMENTS_SUCCESS = 'DEPARTMENTS/GET_DEPARTMENTS_SUCCESS';
export const GET_DEPARTMENTS_ERROR = 'DEPARTMENTS/GET_DEPARTMENTS_ERROR';

export const CREATE_DEPARTMENT_REQUEST = 'DEPARTMENTS/CREATE_DEPARTMENT_REQUEST';
export const CREATE_DEPARTMENT_SUCCESS = 'DEPARTMENTS/CREATE_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_ERROR = 'DEPARTMENTS/CREATE_DEPARTMENT_ERROR';

export const UPDATE_DEPARTMENT_REQUEST = 'DEPARTMENTS/UPDATE_DEPARTMENT_REQUEST';
export const UPDATE_DEPARTMENT_SUCCESS = 'DEPARTMENTS/UPDATE_DEPARTMENT_SUCCESS';
export const UPDATE_DEPARTMENT_ERROR = 'DEPARTMENTS/UPDATE_DEPARTMENT_ERROR';

export const RESET_DEPARTMENT_STATE = 'DEPARTMENTS/RESET_DEPARTMENT_STATE';

export const GET_AUDIT_DEPARTMENTS_REQUEST = 'DEPARTMENTS/GET_AUDIT_DEPARTMENTS_REQUEST';
export const GET_AUDIT_DEPARTMENTS_SUCCESS = 'DEPARTMENTS/GET_AUDIT_DEPARTMENTS_SUCCESS';
export const GET_AUDIT_DEPARTMENTS_ERROR = 'DEPARTMENTS/GET_AUDIT_DEPARTMENTS_ERROR';
